export default __webpack_public_path__ + "static/media/ExpandirMenu.5f06534f.svg";